export default __webpack_public_path__ + "static/media/35.5d120fc8.png";